var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__funko-logo-wrapper",class:[
        {
            'cz2__funko-logo--is-name': _vm.isNameStep,
            'cz2__funko-logo--is-review': _vm.isReviewStep,
            'cz2__funko-logo--is-checkout': _vm.isCheckoutStep,
        },
    ]},[(!_vm.isNameStep)?_c('span',{staticClass:"cz2__funko-logo-link"},[_c('img',{staticClass:"cz2__funko-logo",attrs:{"src":require("../assets/images/branded/pokemon/funko-logo.svg"),"alt":_vm.$t('LOGO_FUNKO')}})]):_vm._e(),(!_vm.isNameStep)?_c('span',{staticClass:"sm-x-icon"}):_vm._e(),(_vm.isMariners)?_c('img',{staticClass:"sm-seattle-logo",attrs:{"src":require("../assets/images/branded/pokemon/pokemon-logo.svg"),"alt":"Pokemon Logo"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }